import {
  Image,
  Modal,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { urlStart } from "../../../utility/Index";
import {
  createSubscription,
  updateSubscription,
} from "../../../services/profileAPI";
import { toast } from "react-toastify";
import * as Linking from "expo-linking";
import { getLoginData } from "../../../utility/AppStoreData";
import { ShowLoader } from "../../../common/ShowLoader";
import { useAuthProvider } from "../../../context/AuthContext";
import { ActivityIndicator } from "react-native-paper";
import SvgImage from "../../../Components/choose-avatar-components/SvgImage";

export default function UpgradeModal(props) {
  const {
    showModal = false,
    setShowModal,
    eventType,
    backTapped,
    isUpdate = false,
  } = props;
  const [showLoader, setShowLoader] = useState(false);

  const [userData, setUserData] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState("oneMonth");
  const { isActiveSubscriptionFound } = useAuthProvider();
  const onCloseClick = () => {
    setShowModal(false);
  };
  useEffect(() => {
    getLoginUserData();
  }, []);
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [benefits, setBenefits] = useState([
    {
      id: 1,
      image: AppImages.BenefitsEarnings,
      width: 61,
      height: 61,
      heading: "Increased Earnings",
      desc: "Keep 80% of your winnings and earnings (vs. 50% for non-subscribers)",
    },
    {
      id: 2,
      image: AppImages.BenefitsPriority,
      width: 53,
      height: 50,
      heading: "Priority Support",
      desc: "Access to faster, priority customer support",
    },
    {
      id: 3,
      image: AppImages.BenefitsEnhanced,
      width: 54,
      height: 53,
      heading: "Enhanced Visibility",
      desc: "Priority placement fo your profile and events on the platform",
    },
    {
      id: 4,
      name: "Jacob",
      image: AppImages.BenefitsExclusive,
      width: 61,
      height: 60,
      heading: "Exclusive Content and Features",
      desc: "Early access to new features and exclusive content",
    },
    {
      id: 5,
      image: AppImages.BenefitsBoosted,
      width: 46,
      height: 64,
      heading: "Boosted Credibility:",
      desc: "Subscription badge on your profile for increased trustworthiness in the community",
    },
  ]);
  async function paymentCreateSessionAPI({
    AccessToken,
    planId,
    successCallback,
  }) {
    setShowLoader(true);

    try {
      let data;
      if (isActiveSubscriptionFound) {
        data = await updateSubscription(AccessToken, planId);
      } else {
        data = await createSubscription(AccessToken, planId);
      }
      if (data.statusCode === 303) {
        setShowLoader(false);
        successCallback(data);
      } else {
        toast.error(
          data.body.error || "An error occurred during payment session creation"
        );
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    } finally {
      setShowLoader(false);
      onCloseClick();
    }
  }
  const handlePurchase = (planId) => {
    paymentCreateSessionAPI({
      AccessToken: userData?.AccessToken,
      planId: planId,
      successCallback: (successData) => {
        Linking.openURL(successData.body.url);
      },
    });
  };
  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
    }
  }
  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
  };

  const handleContinue = () => {
    handlePurchase(selectedPlan);
  };
  const isSmallOrXS =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View style={styles.header}>
            <TouchableOpacity onPress={onCloseClick} activeOpacity={0.5}>
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height: 28,
                  width: 28,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              source={AppImages.vsUpgrade}
              style={{ height: 50, width: 50, resizeMode: "contain" }}
            />
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_32,
                {
                  fontSize: 24,
                  color: AppColors.white,
                },
              ]}
            >
              Upgrade to Pro
            </Text>
          </View>
          <ScrollView
            contentContainerStyle={{ flexGrow: 1 }} // Ensures content takes full width for scrolling
            showsVerticalScrollIndicator={false} // Optional: Hide the horizontal scrollbar
          >
            {/* <View style={styles.divider} /> */}
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_20,
                {
                  color: AppColors.white,
                  textAlign: "justify",
                  lineHeight: 25,
                  paddingVertical: 20,
                  fontWeight: 700,
                },
              ]}
            >
              Benefits
            </Text>
            <View style={styles.benefitsData}>
              {benefits.map((item) => (
                <View
                  style={{
                    flexDirection: "row",
                    gap: 20,
                  }}
                >
                  <SvgImage src={item.image} variant="proPopup" item={item} />
                  <View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          paddingBottom: 5,
                          color: AppColors.white,
                          fontWeight: 700,
                        },
                      ]}
                    >
                      {item.heading}
                    </Text>
                    <Text style={styles.benefitsDesc}>{item.desc}</Text>
                  </View>
                </View>
              ))}
            </View>
            <View style={styles.divider} />
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_20,
                {
                  color: AppColors.white,
                  textAlign: "justify",
                  lineHeight: 25,
                  paddingVertical: 20,
                  fontWeight: 700,
                },
              ]}
            >
              PLANS
            </Text>
            <View style={styles.planSelection}>
              <TouchableOpacity onPress={() => handlePlanSelect("oneMonth")}>
                <View style={styles.plansData}>
                  <View
                    style={{
                      flexDirection: "row",
                      gap:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 12
                          : 30,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        height: 25,
                        width: 25,
                        aspectRatio: 1,
                        backgroundColor:
                          selectedPlan === "oneMonth"
                            ? AppColors.appViolentColor_6D08C3
                            : AppColors.gray_6E90B4,
                        borderRadius: 100,
                      }}
                    ></View>
                    <View style={{ width: 200 }}>
                      <View
                        style={{
                          flexDirection: "row",
                          gap:
                            deviceSize === DEVICE_SIZES.XS ||
                            deviceSize === DEVICE_SIZES.SM
                              ? 15
                              : 30,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_15,
                            {
                              textAlign: "justify",
                              //   paddingVertical: 20,
                              fontWeight: 700,
                              lineHeight: 17,
                            },
                          ]}
                        >
                          1 Month
                        </Text>
                        <View style={styles.battleBgViewStyle}>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                                paddingHorizontal: 9,
                                paddingVertical: 3,
                              },
                            ]}
                          >
                            Most Popular
                          </Text>
                        </View>
                      </View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.gray_6E90B4,
                            paddingVertical: 3,
                            fontWeight: 700,
                            paddingTop: 10,
                          },
                        ]}
                      >
                        Renews every 30 days at 14.99
                      </Text>
                    </View>
                  </View>
                  <View>
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? AppFontStyle.REGULAR_ANYBODY_22
                          : AppFontStyle.REGULAR_ANYBODY_28,
                        {
                          textAlign: "justify",
                          // paddingVertical: 20,
                          fontWeight: 700,
                          lineHeight: 32.34,
                        },
                      ]}
                    >
                      $12.99
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
              <TouchableOpacity onPress={() => handlePlanSelect("threeMonth")}>
                <View style={styles.plansData}>
                  <View
                    style={{
                      flexDirection: "row",
                      gap:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 12
                          : 30,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        height: 25,
                        width: 25,
                        aspectRatio: 1,
                        backgroundColor:
                          selectedPlan === "threeMonth"
                            ? AppColors.appViolentColor_6D08C3
                            : AppColors.gray_6E90B4,
                        borderRadius: 100,
                      }}
                    ></View>
                    <View style={{ width: 200 }}>
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 30,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_15,
                            {
                              textAlign: "justify",
                              //   paddingVertical: 20,
                              fontWeight: 700,
                              lineHeight: 17,
                            },
                          ]}
                        >
                          3 Month
                        </Text>
                        <View style={styles.battleBgViewStyle}>
                          {/* <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.white,
                          paddingHorizontal: 9,
                          paddingVertical: 3,
                        },
                      ]}
                    >
                      Most Popular
                    </Text> */}
                        </View>
                      </View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.gray_6E90B4,
                            paddingVertical: 3,
                            fontWeight: 700,
                            paddingTop: 10,
                          },
                        ]}
                      >
                        Renews every 90 days at 35.97
                      </Text>
                    </View>
                  </View>
                  <View>
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? AppFontStyle.REGULAR_ANYBODY_22
                          : AppFontStyle.REGULAR_ANYBODY_28,
                        {
                          textAlign: "justify",
                          // paddingVertical: 20,
                          fontWeight: 700,
                          lineHeight: 32.34,
                        },
                      ]}
                    >
                      $29.97
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
              <TouchableOpacity onPress={() => handlePlanSelect("twelveMonth")}>
                <View style={styles.plansData}>
                  <View
                    style={{
                      flexDirection: "row",
                      gap:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 12
                          : 30,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        height: 25,
                        width: 25,
                        aspectRatio: 1,
                        backgroundColor:
                          selectedPlan === "twelveMonth"
                            ? AppColors.appViolentColor_6D08C3
                            : AppColors.gray_6E90B4,
                        borderRadius: 100,
                      }}
                    ></View>
                    <View style={{ width: 200 }}>
                      <View
                        style={{
                          flexDirection: "row",
                          gap:
                            deviceSize === DEVICE_SIZES.XS ||
                            deviceSize === DEVICE_SIZES.SM
                              ? 15
                              : 30,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_15,
                            {
                              textAlign: "justify",
                              //   paddingVertical: 20,
                              fontWeight: 700,
                              lineHeight: 17,
                            },
                          ]}
                        >
                          12 Month
                        </Text>
                        <View style={styles.battleBgViewStyle}>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                                paddingHorizontal: 9,
                                paddingVertical: 3,
                              },
                            ]}
                          >
                            Best Value
                          </Text>
                        </View>
                      </View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.gray_6E90B4,
                            paddingVertical: 3,
                            fontWeight: 700,
                            paddingTop: 10,
                          },
                        ]}
                      >
                        Renews every 365 days at 119.88
                      </Text>
                    </View>
                  </View>
                  <View>
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? AppFontStyle.REGULAR_ANYBODY_22
                          : AppFontStyle.REGULAR_ANYBODY_28,
                        {
                          textAlign: "justify",
                          // paddingVertical: 20,
                          fontWeight: 700,
                          lineHeight: 32.34,
                        },
                      ]}
                    >
                      $95.88
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
            </View>

            <View
              style={{
                alignItems: "center",
                paddingVertical: 25,
                paddingHorizontal: 10,
              }}
            >
              <TouchableOpacity
                style={{
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  borderRadius: 10,
                  width: 150,
                  paddingVertical: 12,
                  paddingHorizontal: 25,
                  ...(showLoader && { opacity: 0.5 }),
                }}
                activeOpacity={showLoader ? 0.5 : 1}
                onPress={handleContinue}
                disabled={showLoader}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_16,
                    { textAlign: "center" },
                  ]}
                >
                  Continue
                </Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </View>
      </View>
      <ShowLoader showIndicater={showLoader} isBackGround={true} />
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "50%",
      height: "95%",
      backgroundColor: AppColors.appBlueColor_3A5175,
      paddingHorizontal: 30,
      //   margin: 30,
      alignSelf: "center",
      borderRadius: 12,
    },
    battleBgViewStyle: {
      backgroundColor: AppColors.appGreenColor_51AF07,
      borderRadius: 7,
      alignSelf: "flex-start",
    },
    planSelection: {
      gap: 20,
    },
    planRow: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 10,
    },
    planCircle: {
      height: 25,
      width: 25,
      borderRadius: 12.5,
      borderWidth: 2,
      borderColor: AppColors.gray_6E90B4,
      marginRight: 10,
    },
    selectedCircle: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
    },
    planText: {
      fontSize: 16,
      color: AppColors.white,
    },
    header: {
      paddingTop: 10,
      alignItems: "flex-end",
      //   flexDirection: "row",
      //   justifyContent: "space-between",
      //   paddingVertical: 25,
      //   paddingHorizontal: 10,
      //   alignItems: "center",
    },
    divider: {
      marginTop: 20,
      height: 2,
      alignSelf: "center",
      backgroundColor: AppColors.gray_A3A3A3,
      width: "100%",
    },
    buttonStyle: {
      flex: 1,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderRadius: 12,
      justifyContent: "center",
      alignItems: "center",
    },
    buttonTextStyle: {
      fontSize: 16,
    },
    footerText: {
      flexDirection: "row",
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      paddingHorizontal: 16,
      paddingVertical: 16,
      borderRadius: 10,
      marginBottom: 20,
      gap: 5,
      alignItems: "center",
    },
    benefitsDesc: {
      paddingBottom: 5,
      color: AppColors.white,
      fontWeight: 700,
      fontSize: 12,
    },
    benefitsData: {
      gap: 20,
      flex: 1,
      marginRight: 10,
      marginLeft: 30,
    },
    plansData: {
      flexDirection: "row",
      gap: 200,
      alignItems: "center",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "60%",
        backgroundColor: AppColors.appBlueColor_3A5175,
        paddingHorizontal: 25,
        // margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        paddingTop: 10,
        // flexDirection: "row",
        // justifyContent: "space-between",
        // paddingVertical: 25,
        // paddingHorizontal: 10,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "70%",
        backgroundColor: AppColors.appBlueColor_3A5175,
        paddingHorizontal: 16,
        // margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        paddingTop: 10,
        // flexDirection: "row",
        // justifyContent: "space-between",
        // paddingVertical: 25,
        // paddingHorizontal: 10,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "60%",
        height: "90%",
        backgroundColor: AppColors.appBlueColor_3A5175,
        paddingHorizontal: 16,
        // margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        paddingTop: 10,
        // flexDirection: "row",
        // justifyContent: "space-between",
        // paddingVertical: 25,
        // paddingHorizontal: 10,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
      benefitsDesc: {
        width: "55%",
        wordBreak: "break-word",
      },
      benefitsData: {
        marginLeft: 10,
      },
      plansData: {
        gap: 0,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "90%",
        height: "90%",
        backgroundColor: AppColors.appBlueColor_3A5175,
        paddingHorizontal: 16,
        // margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        paddingTop: 10,
        // flexDirection: "row",
        // justifyContent: "space-between",
        // paddingVertical: 25,
        // paddingHorizontal: 10,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 16,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
      benefitsDesc: {
        width: "55%",
        wordBreak: "break-word",
      },
      benefitsData: {
        marginLeft: 10,
      },
      plansData: {
        gap: 0,
      },
    },
  }
);
